import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Create a GenerateInput component that will allow for
    users to enter text that is saved into the form.
  </p>
    </div>
    <p>{`In the previous step we created the form that will contain all of the fields for creating a recipe. In this step we will create a `}<inlineCode parentName="p">{`<GenerateInput>`}</inlineCode>{` component which can be used for allowing users to enter text inputs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/GenerateFields.tsx"
      }}>{`import { Row, Col, Form, Input } from 'antd';

type InputType = {
  name: string;
  value: string;
  handleInputChange?: (event: any) => void;
};

export const GenerateInput = ({
  name,
  value,
  handleInputChange,
}: InputType) => (
  <Row>
    <Col span={12} offset={6}>
      <Form.Item label={\`\${name}\`}>
        <Input
          placeholder={\`\${name}\`}
          name={\`\${name}\`}
          value={value}
          onChange={handleInputChange}
        />
      </Form.Item>
    </Col>
  </Row>
);

`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` works as a controlled component because it receives its value from the `}<inlineCode parentName="p">{`value`}</inlineCode>{` parameter and after a change has been made, we call an `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` handler which will take the updated contents of the input field and assigns it to a state that we are storing in the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` hook. We also need to add the `}<inlineCode parentName="p">{`handleInputChange`}</inlineCode>{` function to the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` hook. This function will clone the current state of the form and update the field that changed with the new contents of the field. We ensure that the keys of the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` state object matches the `}<inlineCode parentName="p">{`name`}</inlineCode>{` in the `}<inlineCode parentName="p">{`<Input>`}</inlineCode>{` component so that we can easily know where to update the field when using the `}<inlineCode parentName="p">{`_.set()`}</inlineCode>{` function call in the `}<inlineCode parentName="p">{`handleInputChange`}</inlineCode>{` function.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-utils/submitForm.ts"
      }}>{`import { useState } from 'react';
import * as _ from 'lodash';

export const submitForm = (initialValues, callback) => {
  const [inputs, setInputs] = useState(initialValues);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => {
      const newInputs = _.cloneDeep(inputs);
      _.set(newInputs, event.target.name, event.target.value);
      return newInputs;
    });
  };

  const handleSubmit = () => {
    callback();
    setInputs(() => ({ ...initialValues }));
  };

  return {
    inputs,
    handleSubmit,
    handleInputChange,
  };
};

`}</code></pre>
    <p>{`After creating the new `}<inlineCode parentName="p">{`<GenerateInput>`}</inlineCode>{` component and updating the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` hook to handle form changes, we can actually use the `}<inlineCode parentName="p">{`<GenerateInput>`}</inlineCode>{` in our form to manage the `}<inlineCode parentName="p">{`title`}</inlineCode>{` parameter. We will show in the next step that adding additional parameters in recipe is as simple as calling the `}<inlineCode parentName="p">{`<GenerateInput>`}</inlineCode>{` for each text input field.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/CreateRecipe.tsx"
      }}>{`import { Row, Col, Form, Button } from 'antd';
import { submitForm } from '../utils/submitForm';
import { GenerateInput } from './GenerateFields';

export const CreateRecipe = () => {
  const initiateCreateRecipe = () => {
    console.log('submitted form');
  };

  const { inputs, handleInputChange, handleSubmit } = submitForm(
    {
      title: '',
      description: '',
    },
    initiateCreateRecipe,
  );

  return (
    <Form onFinish={handleSubmit}>
      <GenerateInput
        name="title"
        value={inputs.title}
        handleInputChange={handleInputChange}
      />
      <GenerateInput
        name="description"
        value={inputs.description}
        handleInputChange={handleInputChange}
      />
      <Row>
        <Col span={16} />
        <Col span={4}>
          <Form.Item label="Create Recipe">
            <Button type="primary" htmlType="submit">
              Create Recipe
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      